'use strict';

export default function commonApiRemote(dataUrl: string) {
    var service = {
        saveData: saveData,
        deleteDataById: deleteDataById,
        getData: getData
    };

    return service;

  function saveData(data: any) {
        return httpPost(dataUrl, data);
    }

    function deleteDataById(id: any) {
        return httpDelete(dataUrl + '/' + id);
    }

    function getData() {
        return httpGet(dataUrl);
    }

    function httpExecute(requestUrl: string, method: string, data: any) {
        let ajax = $.ajax({
            url: requestUrl,
            method: method,
            data: data,
            processData: false,
            contentType: false

        }).then(function (data: any, textStatus: string, jqXHR: object) {

            console.log('**response from EXECUTE', jqXHR);

            return data;
        },
            function (jqXHR: object, textStatus: string, errorThrown: any) {
                console.log('**response from EXECUTE', jqXHR);
             });

        return ajax;
    }

    function httpDelete(url: string) {
        return httpExecute(url, 'DELETE', null);
    }

    function httpGet(url: string) {
        return httpExecute(url, 'GET', null);
    }

    function httpPut(url: string, data: any) {
        return httpExecute(url, 'PUT', data);
    }

    function httpPost(url: string, data: any) {
        return httpExecute(url, 'POST', data);
    }

    function saveItem(url: string, item: any) {
        if (item.id) {
            return httpPut(url + '/' + item.id, item);
        } else {
            return httpPost(url, item);
        }
    }
}




// WEBPACK FOOTER //
// ./static-content/private/javascripts/services/commonApiRemote.ts